/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Property_Link_Rule_Type_AutoopeninappInputs */

const en_enum_custom_property_link_rule_type_autoopeninapp = /** @type {(inputs: Enum_Custom_Property_Link_Rule_Type_AutoopeninappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property Link Rule Type Autoopeninapp`)
};

const de_enum_custom_property_link_rule_type_autoopeninapp = /** @type {(inputs: Enum_Custom_Property_Link_Rule_Type_AutoopeninappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link automatisch in der App öffnen`)
};

/**
* | output |
* | --- |
* | "Property Link Rule Type Autoopeninapp" |
*
* @param {Enum_Custom_Property_Link_Rule_Type_AutoopeninappInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_property_link_rule_type_autoopeninapp = /** @type {((inputs?: Enum_Custom_Property_Link_Rule_Type_AutoopeninappInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Property_Link_Rule_Type_AutoopeninappInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_property_link_rule_type_autoopeninapp(inputs)
	return de_enum_custom_property_link_rule_type_autoopeninapp(inputs)
});